'use client'

import { OverlayButton } from '@fukku/button/Overlay/OverlayButton'
import { OverlayButtonVariant } from '@fukku/button/Overlay/types'
import type { FavoriteButtonOverlayProps } from 'favorite/types/types'
import { IconFavoffL } from 'icons/components/IconFavoffL'
import { IconFavoffS } from 'icons/components/IconFavoffS'
import { useMemo } from 'react'

import { useFavorite } from '../hooks/useFavorite'

const ICON_WIDTH = 20
const ICON_HEIGHT = 20

/**
 * Favorite overlay button used mainly in PDP.
 * Label is shown only if the showLabel parameter is true.
 */
export const FavoriteButtonOverlay = ({
	productId,
	onClickCallback,
	dataTestIds,
	notification = false,
	selectedColorId,
	location,
	variant = OverlayButtonVariant.IconSmall,
	className,
}: FavoriteButtonOverlayProps) => {
	const { isFavorite, handleClick, buttonLabel, showButton } = useFavorite({
		selectedColorId,
		productId,
		notification,
		onClickCallback,
		location,
		isSavedForLater: false,
	})

	const iconProps = useMemo(
		() => ({
			width: ICON_WIDTH,
			height: ICON_HEIGHT,
			alt: buttonLabel,
		}),
		[buttonLabel]
	)

	if (!showButton) {
		return null
	}

	const dataTestId = isFavorite ? dataTestIds.active : dataTestIds.inactive
	const icon = isFavorite ? (
		<IconFavoffS {...iconProps} />
	) : (
		<IconFavoffL {...iconProps} />
	)

	return (
		<OverlayButton
			onClick={handleClick}
			data-testid={dataTestId}
			icon={icon}
			className={className}
			variant={variant}
		/>
	)
}
